@if (compact()) {
  <span #tooltipTarget class="line-clamp-3 w-full font-mono text-xs break-all">
    {{ compact() }}
  </span>
  <app-tooltip
    [target]="tooltipTarget"
    [content]="tooltipContent()"
    [position]="'top'"
    [minWidth]="160"
    [maxWidth]="480" />
} @else {
  <span class="text-text-tertiary">—</span>
}
